export function deleteKeyFromObject(key: string, object: any) {
  try {
    const newFilters = { ...object };
    delete newFilters[key];
    return newFilters;
  } catch (e) {
    throw e;
  }
}

export function preparePayload(
  tempPayload: any,
  filter: any,
  search: any,
  newPage: any
) {
  if (filter != undefined && filter !== '') {
    tempPayload = { ...tempPayload, ...filter };
  }

  tempPayload = { ...tempPayload, page: newPage + 1 };

  if (search !== undefined && search !== '') {
    tempPayload = { ...tempPayload, search };
  }

  if (search === undefined || search === '') {
    delete tempPayload['search'];
  }

  return tempPayload;
}

export function getCurrency(adminData: any) {
  switch (adminData) {
    case 'USA':
      return ' (US$)';
    case 'Canada':
      return ' (CAD$)';
    default:
      return ' (US$)';
  }
}
